import { render, staticRenderFns } from "./controlruleDataList.vue?vue&type=template&id=d8ed6ff0&scoped=true"
import script from "./controlruleDataList.vue?vue&type=script&lang=js"
export * from "./controlruleDataList.vue?vue&type=script&lang=js"
import style0 from "./controlruleDataList.vue?vue&type=style&index=0&id=d8ed6ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ed6ff0",
  null
  
)

export default component.exports